import styled from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const Root = styled.div``;

export const RightItems = styled.span`
  align-items: flex-end;
`;

export const RightButton = styled.div`
  opacity: 0;
  overflow: hidden;
  position: relative;
  display: inline-flex;
  transition: opacity 150ms ease-in-out;
  height: 16px;

  .tooltip {
    display: flex;
  }

  &:hover {
    color: ${GrayColors["G-8"]};
  }
`;

export const Title = styled.div`
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
  min-height: 29px;
  padding-left: 8px;
  font-family: monospace, sans-serif;
  border-radius: 8px;
  border: 1px solid transparent;

  &:hover {
    background-color: ${GrayColors["G-0-5"]};
    border-color: ${GrayColors["G-1"]};
    ${RightButton} {
      opacity: 1;
      transition: opacity 200ms ease-in-out;
    }
  }

  span {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const Text = styled.div`
  display: inline-flex;
  color: ${TextColorNames.tertiary};
  font-size: 13px;
  font-weight: 500;
  padding-left: 8px;
  line-height: 18px;
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  padding-right: 3px;
`;

export const TextWrapper = styled.div`
  display: inline-flex;
  padding: 5px;
`;
